module.exports = __webpack_public_path__ + "static/img/12.c8f97d0.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/5/1/sp/12.png
// module id = ccax
// module chunks = 0